import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import { restActionFactory } from "../../toolkit/axiosActions/axiosActionsFactory";
import axios from "axios";

const NOTAS_CREDITO_BASE_URL = "/api/maintenances/notas-credito";
const CANCELACIONES_PROCESO_BASE_URL =
  "/api/maintenances/cancelaciones-proceso";

// Facturas bloqueadas para generar notas de crédito
export const getNotaCreditoBloqueadas = (): IAction => {
  return notaCreditoRestAction({
    urlComplement: `/bloqueo/listado`,
    actionType: actionTypes.GET_NOTA_CREDITO_BLOQUEADAS,
    method: "get"
  });
};

// Bloqueo de factura para generar nota de crédito o cancelación
export const postNotaCreditoBloqueada = (facturaFolio: string): IAction => {
  return notaCreditoRestAction({
    urlComplement: `/bloqueo/${facturaFolio}`,
    actionType: actionTypes.POST_NOTA_CREDITO_BLOQUEADA,
    method: "post"
  });
};

// Bloqueo de factura para generar nota de crédito o cancelación
export const deleteNotaCreditoBloqueada = (facturaUUID: string): IAction => {
  return notaCreditoRestAction({
    urlComplement: `/bloqueo/${facturaUUID}`,
    actionType: actionTypes.DELETE_NOTA_CREDITO_BLOQUEADA,
    method: "delete"
  });
};

// Carga de archivo de fechas de cancelaciones del SAT
export const postUploadSatCancelaciones = (file): Promise<any> => {
  const data = new FormData();
  data.append("file", file);

  return axios.post(
    `${constants.BASE_URL}${NOTAS_CREDITO_BASE_URL}/sat-cancelaciones/upload`,
    data,
    {
      withCredentials: true
    }
  );
};

// Procesamiento de fechas de cancelaciones del SAT
export const postSatCancelacionesConfirmar = (
  porCambiarFecha
): Promise<any> => {
  return axios.post(
    `${constants.BASE_URL}${NOTAS_CREDITO_BASE_URL}/sat-cancelaciones/confirmar`,
    porCambiarFecha,
    {
      withCredentials: true
    }
  );
};

// Obtener cancelaciones en proceso por período
export const getCancelacionesByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_CANCELACIONES_BY_PERIODO,
    payload: {
      promise: axios.get(
        `${constants.BASE_URL}${CANCELACIONES_PROCESO_BASE_URL}/periodo/${periodo}`,
        {
          withCredentials: true
        }
      )
    }
  };
};

// Obtener cancelaciones en proceso por folio
export const getCancelacionesByFolio = (folioFactura: string): IAction => {
  return {
    type: actionTypes.GET_CANCELACIONES_BY_FOLIO,
    payload: {
      promise: axios.get(
        `${constants.BASE_URL}${CANCELACIONES_PROCESO_BASE_URL}/folio/${folioFactura}`,
        {
          withCredentials: true
        }
      )
    }
  };
};

// Obtener intentos de verificación de cancelación por factura
export const getCancelacionesIntentosByFactura = (
  idFactura: number
): IAction => {
  return {
    type: actionTypes.GET_CANCELACIONES_INTENTOS_BY_FACTURA,
    payload: {
      promise: axios.get(
        `${constants.BASE_URL}${CANCELACIONES_PROCESO_BASE_URL}/intentos/${idFactura}`,
        {
          withCredentials: true
        }
      )
    }
  };
};

// Verificar cancelación
export const postVerificarCancelacion = (uuid: string): IAction => {
  return {
    type: actionTypes.POST_VERIFICAR_CANCELACION,
    payload: {
      promise: axios.post(
        `${constants.BASE_URL}/api/maintenances/nota-credito/verificar-cancelacion/${uuid}`,
        {},
        {
          withCredentials: true
        }
      )
    }
  };
};

// Confirmar cancelación manualmente
export const postConfirmarCancelacion = (uuid: string): IAction => {
  return {
    type: actionTypes.POST_CONFIRMAR_CANCELACION,
    payload: {
      promise: axios.post(
        `${constants.BASE_URL}/api/maintenances/nota-credito/confirmar-cancelacion/${uuid}`,
        {},
        {
          withCredentials: true
        }
      )
    }
  };
};

// Reenviar solicitud de cancelación
export const postReenviarSolicitudCancelacion = (uuid: string): IAction => {
  return {
    type: actionTypes.POST_REENVIAR_SOLICITUD_CANCELACION,
    payload: {
      promise: axios.post(
        `${constants.BASE_URL}/api/maintenances/nota-credito/reenviar-solicitud-cancelacion/${uuid}`,
        {},
        {
          withCredentials: true
        }
      )
    }
  };
};

// Función que genera IAction's para manipular Notas de Crédito
const notaCreditoRestAction = restActionFactory(
  `${constants.BASE_URL}${NOTAS_CREDITO_BASE_URL}`
);
